import { render } from "./MessageOperationsView.vue?vue&type=template&id=407aafd2"
import script from "./MessageOperationsView.vue?vue&type=script&lang=js"
export * from "./MessageOperationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__